/* eslint-disable camelcase */
export enum VisibilityConditionOptions {
    BOOLEAN = 'boolean',
    VISIBLE_FROM = 'visibleFrom',
    VISIBLE_WHEN = 'visibleWhen',
}

export interface WorkspaceConditions {
    [role: string]: WorkspaceCondition[];
}

export interface WorkspaceCondition {
    name: string;
    conditionType: string;
}

export type WorkspaceSchemeName = {
    [locale: string]: string;
};

export type WorkspaceGroup = {
    type: string;
    extraGroup?: boolean;
    workspaces: WorkspaceItem[];
};

export type HtmlContent = {
    type: string;
    workspace_ref: string;
    ci_id: number;
};

export interface WorkspaceBasicItem {
    visible: boolean;
    visibleFrom?: string;
    visibleWhen?: string;
    description?: string;
    icon?: string;
    separator?: boolean;
}

export interface InternalReferenceWorkspaceItem extends WorkspaceBasicItem {
    internal_ref: string;
}

export interface ContentItemReferenceWorkspaceItem extends WorkspaceBasicItem {
    contentItemId: number;
    name?: string;
}

export interface ContentRevisionReferenceWorkspaceItem extends WorkspaceBasicItem {
    contentRevisionId: number;
    name?: string;
}

export type WorkspaceItem =
InternalReferenceWorkspaceItem | ContentItemReferenceWorkspaceItem | ContentRevisionReferenceWorkspaceItem;

export enum TabPaneTypes {
    PLANNER = 'ar_plan',
    GRADER = 'ar_evaluate',
    REPORTER = 'ar_report',
    STUDENT = 'student',
}

export type TabPane = | TabPaneTypes.PLANNER | TabPaneTypes.GRADER | TabPaneTypes.REPORTER | TabPaneTypes.STUDENT;
